<template>
  <span
    class="dashboard-menu-item"
    :class="{
      'dashboard-menu-item--child': !showIcon,
      'dashboard-menu-item--icon-only': iconOnly,
    }"
  >
    <i v-if="showIcon && item.icon" :class="['dashboard-menu-item__icon', item.icon]" />
    <span class="dashboard-menu-item__label">{{ item.linkLabel }}</span>
    <span v-if="badgeCount" class="dashboard-menu-item__badge">{{ badgeCount }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Menu {
  id: number;
  linkTo: string;
  linkLabel: string;
  icon?: string;
  children?: Menu[];
  badge?: number | string;
  badgeCount?: number | string;
  count?: number | string;
  pendingCount?: number | string;
}

const props = withDefaults(
  defineProps<{
    item: Menu;
    showIcon?: boolean;
    iconOnly?: boolean;
  }>(),
  { showIcon: true, iconOnly: false }
);

const badgeCount = computed(() => {
  const value =
    props.item.badge ??
    props.item.badgeCount ??
    props.item.count ??
    props.item.pendingCount;
  if (value === undefined || value === null || value === "") {
    return "";
  }
  return String(value);
});
</script>

<style scoped>
.dashboard-menu-item {
  display: inline-flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}

.dashboard-menu-item__label {
  flex: 1;
  min-width: 0;
}

.dashboard-menu-item__badge {
  flex-shrink: 0;
  min-width: 26px;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(177, 150, 99, 0.2);
  color: var(--primary-gold-light, #f4d03f);
  border: 1px solid rgba(177, 150, 99, 0.45);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
}
</style>
